import React from 'react';

export default function StudyFocusPopup({ onDismiss }) {
  return (
    <div style={s.overlay}>
      <div style={s.modal}>
        <span className="material-symbols-outlined" style={{ fontSize: 48, color: '#f59e0b' }}>
          psychology
        </span>
        <h3 style={s.title}>Focus on studying!</h3>
        <p style={s.text}>
          You&apos;ve been idle for a while. Don&apos;t waste time scrolling or watching videos without engaging.
          Return to your lesson and stay focused on your GED preparation.
        </p>
        <button type="button" onClick={onDismiss} style={s.btn}>
          I&apos;m back to studying
        </button>
      </div>
    </div>
  );
}

const s = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(15,23,42,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: 20,
  },
  modal: {
    background: '#fff',
    borderRadius: 16,
    padding: '28px 32px',
    maxWidth: 400,
    textAlign: 'center',
    boxShadow: '0 24px 64px rgba(0,0,0,0.2)',
  },
  title: { margin: '12px 0 8px', fontSize: 20, fontWeight: 800, color: '#1b365d' },
  text: { fontSize: 14, color: '#64748b', lineHeight: 1.6, marginBottom: 20 },
  btn: {
    padding: '12px 24px',
    borderRadius: 10,
    border: 'none',
    background: '#4b00d1',
    color: '#fff',
    fontWeight: 700,
    fontSize: 14,
    cursor: 'pointer',
  },
};
